module.exports = __webpack_public_path__ + "img/weddings_16_V.c57a7ddc.webp";